import(/* webpackMode: "eager" */ "/builds/kor-app/blockchain/kor_ui/apps/creator/src/app/not-found.tsx");
